'use strict';


var Emitter = require('cjs-emitter'),

    listItemRender = require('../renders/list.item');


function Option ( config ) {
    var keys     = Object.keys(config),
        keysSize = keys.length,
        index    = 0,
        events   = config.events,
        event;

    while ( index < keysSize ) {
        this[keys[index]] = config[keys[index]];
        ++index;
    }

    /*
     * this.saveImmediate;
     * this.requirePortalReboot;
     * this.requireDeviceReboot;
     */

    this.events = {};

    Emitter.call(this, config);

    for ( event in events ) {
        this.addListener(event, events[event]);
    }

    if ( typeof this.render === 'undefined' ) {
        this.render = listItemRender;
    }

    this.type = 'option';
    this.cached = null;
    this.advanced = !!config.advanced;
}


// inheritance
Option.prototype = Object.create(Emitter.prototype);
Option.prototype.constructor = Option;


module.exports = Option;
